define('views/modules/questionnaire/questions/questions-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/menu/menu-action',
    'views/parts/list/fetch-list',
    'views/modules/questionnaire/questions/list/question-list-item',
    'views/modules/questionnaire/questions/edit/question-edit-panel',
    'views/parts/alert/alert-no-data',
    // models
    'models/questionnaire/question',
    'collections/questionnaire/questions',
    // templates
    'text!templates/modules/questionnaire/questions/questions-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VMenuAction,
    VFetchList,
    VQuestionListItem,
    VQuestionEditPanel,
    VAlertNoData,
    // models
    MQuestion,
    CQuestions,
    // templates
    TQuestionsContent
) {

    var VQuestionsContent = Backbone.View.extend({
        template: TQuestionsContent,

        regions: {
            root: ".questions-content",
            menu: ".menu-actions",
            alert: ".alert-no-data",
            list: "#questions-list",
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                collection: new CQuestions(),
                group: opt.group,
                url: opt.url
            });

            var collection = this.collection;

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { route: '#', title: i18n.t('messages:tooltip-add-question'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddQuestionAction },
                        { route: '#', title: i18n.t('messages:tooltip-publish-questionnaire'), itemClass: 'pull-right', content: 'questionnaire:Publish questionnaire', icon: 'sl-icon-cloud-upload', callback: this.onPostQuestionnaireAction },
                    ]),
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                list: new VFetchList({
                    collection: collection,
                    item: VQuestionListItem,
                    async: false,
                    sortable: {
                        group: {
                            name: "questions",
                            pull: false,
                            put: true
                        },
                        onUpdate: this.onOrderChange,
                        context: this,
                    }
                }),
                alert: new VAlertNoData({
                    title: 'questionnaire:Add a question',
                    subtitle: 'questionnaire:Click on plus',
                    collection: collection,
                    addClass: 'alert-arrow alert-arrow-left-top'
                })
            };

            this.view.menu.addMoreActions([
                { icon: 'fa fa-link', caption: 'messages:Get the form link', callback: this.onGetLinkAction, context: this },
                // { icon: 'fa fa-file-text-o', caption: 'messages:Show the form view', callback: U.log('Add a function for Afficher le formulaire '), context: this }
            ]);

            this.listenTo(this.model, "sync", this.onModelSync);
            this.listenTo(collection, {
                "remove": this.onCollectionRemove,
                "question:duplicate": this.onQuestionDuplicate,
                "question:remove": this.onQuestionRemove,
                "question:click": this.onQuestionClick
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);

            return this;
        },

        save: function() {
            this.model.save({ questions: this.collection.toArray() }, {
                patch: true
            });
        },

        editPanelLazyInit: function() {
            var view = this.view,
                editView = view.edit;

            if (!editView) {
                editView = view.edit = new VQuestionEditPanel({
                    questionnaire: this.model,
                    group: this.group
                });

                this.listenTo(editView, { 'question:add': this.onAddQuestionAction });
            }

            return editView;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddQuestionAction: function() {
            var panel = this.editPanelLazyInit();
            panel.resetModel();
            this.trigger('panel:stack', panel);
        },

        onPostQuestionnaireAction: function() {
            this.trigger('questionnaire:post', this.model);
        },

        onGetLinkAction: function() {
            this.trigger('questionnaire:link', this.model);
        },

        onQuestionClick: function(model) {
            var panel = this.editPanelLazyInit();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        // (onUpdate) Changed sorting within list
        onOrderChange: function(e) {
            this.collection.move(e.oldIndex, e.newIndex, { silent: true });
            this.save();
        },

        onQuestionDuplicate: function(model) {
            var duplicate = model.duplicate();
            this.collection.add(duplicate);
            this.save();
        },

        onQuestionRemove: function(model) {
            this.collection.remove(model);
            this.save();
        },

        onModelSync: function(model) {
            this.collection.reset(model.getQuestions().models);
        },

    });

    return VQuestionsContent;

});

